"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

require("./search-recently-viewed.css");

var _recentlyViewedProductsFunctions = require("../utils/recently-viewed-products-functions");

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var RecentlyViewed = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(RecentlyViewed, _React$Component);

  var _super = _createSuper2(RecentlyViewed);

  function RecentlyViewed() {
    var _this;

    (0, _classCallCheck2.default)(this, RecentlyViewed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onProductClick", function () {
      (0, _recentlyViewedProductsFunctions.triggerAnalyticsEvents)({
        event: {
          eventDetails: {
            recentlyViewed: 'Recently Viewed - Product',
            productName: _this.props.productName,
            skuCode: _this.props.sku,
            productCode: _this.props.productCode
          },
          eventInfo: {
            eventName: 'recentlyViewedInteraction'
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubCatClick", function () {
      (0, _recentlyViewedProductsFunctions.triggerAnalyticsEvents)({
        event: {
          eventDetails: {
            recentlyViewed: 'Recently Viewed - Sub Category',
            subCategory: _this.props.subCategory,
            productType: _this.props.categoryName
          },
          eventInfo: {
            eventName: 'recentlyViewedInteraction'
          }
        }
      });
    });
    return _this;
  }

  (0, _createClass2.default)(RecentlyViewed, [{
    key: "getBaseURLByBrandType",
    value: function getBaseURLByBrandType(brand) {
      var currentEnv = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();
      var hostName = 'shutterfly';
      var envStr = currentEnv && currentEnv !== 'production' ? "".concat(currentEnv, ".") : '';

      if (brand === 'TP') {
        hostName = 'tinyprints';
      }

      return "https://www.".concat(envStr).concat(hostName, ".com");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          key = _this$props.key,
          categoryName = _this$props.categoryName,
          categoryLink = _this$props.categoryLink,
          productLink = _this$props.productLink,
          productThumbnail = _this$props.productThumbnail,
          productName = _this$props.productName,
          brand = _this$props.brand,
          productCode = _this$props.productCode,
          categoryCode = _this$props.categoryCode,
          sku = _this$props.sku;
      var baseUrl = this.getBaseURLByBrandType(brand);
      var productQueryParams = productCode && categoryCode && sku ? "?productCode=".concat(productCode, "&categoryCode=").concat(categoryCode, "&skuCode=").concat(sku) : '';
      return _react.default.createElement("li", {
        className: 'recently-viewed-item',
        ref: this.myRef // onMouseEnter={this.updateCursor}
        // onMouseLeave={this.resetCursor}

      }, _react.default.createElement("div", {
        tabIndex: "0" // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        ,
        role: "option",
        id: "option-".concat(key)
      }, _react.default.createElement("div", {
        className: "section-1"
      }, _react.default.createElement("a", {
        href: "".concat(baseUrl).concat(categoryLink),
        onClick: this.onSubCatClick
      }, _react.default.createElement("span", {
        className: "item-label"
      }, categoryName), _react.default.createElement("span", null, "View all ", '>'))), _react.default.createElement("div", {
        className: "section-2"
      }, _react.default.createElement("a", {
        href: "".concat(baseUrl).concat(productLink).concat(productQueryParams),
        onClick: this.onProductClick
      }, _react.default.createElement("div", {
        className: "product-image",
        style: {
          backgroundImage: "url(".concat(productThumbnail, ")")
        }
      }), _react.default.createElement("div", {
        className: "product-title"
      }, productName)))));
    }
  }]);
  return RecentlyViewed;
}(_react.default.Component);

exports.default = RecentlyViewed;
(0, _defineProperty2.default)(RecentlyViewed, "propTypes", {
  // cursor: PropTypes.number,
  key: _propTypes.default.number,
  categoryName: _propTypes.default.string,
  categoryLink: _propTypes.default.string,
  productLink: _propTypes.default.string,
  productThumbnail: _propTypes.default.string,
  productName: _propTypes.default.string,
  productCode: _propTypes.default.string,
  sku: _propTypes.default.string,
  subCategory: _propTypes.default.string,
  brand: _propTypes.default.string,
  categoryCode: _propTypes.default.string // onMouseEnter: PropTypes.func,
  // onMouseLeave: PropTypes.func,

});
(0, _defineProperty2.default)(RecentlyViewed, "defaultProps", {
  onKeyDown: function onKeyDown() {},
  categoryName: '',
  categoryLink: '',
  productLink: '',
  productThumbnail: '',
  productName: '',
  productCode: null,
  sku: null,
  brand: '',
  categoryCode: ''
});